import React, { useEffect, useState, useLayoutEffect } from "react";
import { Col, Row } from "react-bootstrap";
import moment from "moment";
import Spinner from "react-bootstrap/Spinner";

//Services
import api from "../../services/api";
import Api from "../../services/api";

//Components
import ReportButtons from "../../Components/reports/ReportButtons";
import FilterBox from "../../Components/filterBox/filterBox";
import TableList from "../../Components/tableList/TableList";
import MessageTable from "../../Components/messageTable/MessageTable";
import DatePicker from "../../Components/datePicker/datePicker";
import Select from "../../Components/select/select";

//Styles
import "./generalReports.css";
import "./generalReports.css";
import styles from "../General/details.module.css";
import "../../Components/filterBox/filterBox.css";

const ReportOeeWorkShift = () => {
  const [dataFilter, setDataFilter] = useState([]);
  const [control, setControl] = useState([1]);
  const [loading, setLoading] = useState(true);
  const [machines, setMachines] = useState([]);
  const [workShifts, setWorkShifts] = useState([]);
  const [machine, setMachine] = useState(null);
  const [workShift, setWorkShift] = useState(null);
  const [date, setDate] = useState(moment().format("YYYY-MM-DD").toString());

  useEffect(() => {
    function firstLoad() {
      Api.get("/work-shifts/")
        .then((response) => {
          let array = [{ label: "Todos", value: "null" }];

          response.data.forEach((element) => {
            array.push({
              label: element.code,
              value: element.id,
            });
          });
          if (array.length > 0) {
            //Se a quantidade de dados for maior que zero ele salva os dados nos seguintes states: data e dataFilter. Depois ele desabilita a tela de loading.
            setWorkShifts(array);
          }
        })
        .catch((err) => {
          alert(err);
        });

      Api.get("/machines/")
        .then((response) => {
          let array = [{ label: "Todas", value: "null" }];

          response.data.forEach((element) => {
            array.push({
              label: `${element.description}${element.code}`,
              value: element.id,
            });
          });
          if (array.length > 0) {
            //Se a quantidade de dados for maior que zero ele salva os dados nos seguintes states: data e dataFilter. Depois ele desabilita a tela de loading.
            setMachines(array);
          }
        })
        .catch((err) => {
          alert(err);
        });
    }

    firstLoad();
  }, []);

  const selectMachine = (value) => {
    setMachine(value);
  };

  const selectWorkshift = (value) => {
    setWorkShift(value);
  };

  const saveDate = (value) => {
    if (value != "Invalid date") {
      setDate(moment(value, "DD/MM/YYYY").format("YYYY-MM-DD").toString());
    } else {
      setDate(null);
    }
  };

  const button = () => {
    setLoading(true);
    setDataFilter([]);
    setControl([...[1]]);
  };

  // Essa função é executada quando clicamos em um botão.

  useEffect(() => {
    if (machine != null || workShift != null || date != null) {
      api
        .get(
          `/reports/oee-work-shift/?machine=${machine}&work_shift=${workShift}&date=${date}`
        )
        .then((response) => {
          if (response.data.length > 0) {
            let aux = [];
            response.data.forEach((element) => {
              aux.push({
                Máquina: element.machine,
                Turno: element.work_shift,
                Data: moment(element.appointment_date).format("DD/MM/YYYY"),
                OEE: `${element.oee}%`,
                Performance: `${element.performance}%`,
                Disponibilidade: `${element.disponibility}%`,
                Qualidade: `${element.quality}%`,
              });
            });

            setDataFilter(aux);
          } else {
            setDataFilter([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      console.log("Nenhum filtro foi selecionado!");
    }

    setLoading(false);
  }, [control]);

  return (
    <>
      <FilterBox title="Filtros" spacePadding>
        <Row type="input" className="w-100 justify-content-between">
          <Col
            lg={4}
            sm={6}
            xs={12}
            type="input"
            id="filterSelect"
            className="p-1 mb-1 selectFilter"
          >
            {" "}
            <Select
              label="Máquina"
              arrData={machines}
              handleSelect={selectMachine}
            ></Select>
          </Col>
          <Col
            lg={4}
            sm={6}
            xs={12}
            type="input"
            className="p-1 mb-1 selectFilter"
            id="filterSelect"
          >
            {" "}
            <Select
              label="Turno"
              arrData={workShifts}
              handleSelect={selectWorkshift}
            ></Select>
          </Col>
          <Col lg={4} sm={12} type="input" className="p-1 mb-1">
            {" "}
            <DatePicker
              label="Data"
              name="date"
              title="Data"
              parentCallback={saveDate}
            ></DatePicker>
          </Col>
        </Row>
        <ReportButtons
          type="input"
          handleClick={button}
          excelData={dataFilter}
          surnameFile="oee_turno"
        />
      </FilterBox>
      <div className="filters boxReport">
        <div className="TableReport" id="tabela">
          {loading ? (
            <div style={{ marginTop: "20vh" }} className={styles.loader}>
              <Spinner variant="success" animation="border" />
              <strong>Carregando...</strong>
            </div>
          ) : (
            <>
              {dataFilter.length > 0 ? (
                <TableList data={dataFilter}></TableList>
              ) : (
                <MessageTable message={"Sem dados para processar."} />
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ReportOeeWorkShift;
